import React from "react";
import { History, ShieldCheck, UserCheck, Clock } from "lucide-react";
import { useApp } from "../../app/context/AppContext";
import { DataTable } from "../../components/common/DataTable";
import { Badge } from "../../components/common/Badge";
import { formatDateTime } from "../../utils/formatters";

export function AuditLogModule() {
  const { auditLogs } = useApp();

  const columns = [
    {
      header: "Timestamp",
      accessorKey: "timestamp",
      render: (val) => (
        <span className="font-mono text-slate-500 text-[11px]">{val}</span>
      )
    },
    {
      header: "User & Role",
      accessorKey: "user",
      render: (val, row) => (
        <div>
          <span className="font-bold text-slate-900 dark:text-white">{val}</span>
          <p className="text-[10px] text-slate-400 font-mono">{row.role}</p>
        </div>
      )
    },
    {
      header: "System Module",
      accessorKey: "module",
      render: (val) => <Badge variant="blue">{val}</Badge>
    },
    {
      header: "Action Performed",
      accessorKey: "action",
      render: (val) => (
        <span className="font-semibold text-emerald-600 dark:text-emerald-400">
          {val}
        </span>
      )
    },
    {
      header: "Action Details & Audit Reference",
      accessorKey: "details",
      render: (val) => <span className="text-slate-700 dark:text-slate-300 text-xs">{val}</span>
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-slate-900 dark:text-white font-display flex items-center gap-2">
            <History className="w-5 h-5 text-emerald-500" />
            Immutable Audit Trail & Activity Log
          </h2>
          <p className="text-xs text-slate-500">
            Eliminates individual employee dependency: chronological log of every PO, stock adjustment, transfer, and cashier sale
          </p>
        </div>

        <span className="text-xs font-mono font-semibold text-slate-400 bg-slate-100 dark:bg-slate-900 px-3 py-1.5 rounded-xl border border-slate-200 dark:border-slate-800">
          Tamper-Evident Ledger
        </span>
      </div>

      <DataTable
        columns={columns}
        data={auditLogs}
        title="Enterprise Activity Logs"
        subtitle="Search by employee name, action keyword, or module"
        filename="kirana_audit_trail_ledger"
      />
    </div>
  );
}
